import {
  isString,
  isArray,
  findIndex,
  isEmpty,
} from 'underscore';
import {
  SmartPageStatus,
  SmartPageErrorMap,
} from '@bingads-webui-campaign-react/smart-page-data-service';
import { getSmartPageUrlSuffix } from '@bingads-webui-campaign/smart-page-url-suffix-provider';

export const SmartPageUrlSuffix = getSmartPageUrlSuffix(document.domain);

export const getSmartPageUrl = subdomain => (
  `https://${subdomain}${SmartPageUrlSuffix}`
);

export const isSmartPageUrl = website => (
  website && website.endsWith(SmartPageUrlSuffix)
);

export const hasSmartPageAssociation = (smartPageData, campaignId) => (
  isString(campaignId)
    && smartPageData
    && isArray(smartPageData.associations)
    && findIndex(smartPageData.associations, { EntityId: campaignId }) !== -1
);

export const onSmartPageError = (error, showWarningMessage) => {
  if (error && error.body && !isEmpty(error.body.value)) {
    const message = SmartPageErrorMap[error.body.value[0].Code] || SmartPageErrorMap.General;
    showWarningMessage(message);
  } else {
    showWarningMessage(_TL_('An error has occurred. Please try again later.'));
  }
};

export const isSmartPageOnline = smartPageStatus => (
  smartPageStatus === SmartPageStatus.Published
    || smartPageStatus === SmartPageStatus.PendingPublish
    || smartPageStatus === SmartPageStatus.UnpublishedChanges
);
